import axios from 'axios';
import i18n from '../../../i18n';
import { useAuthStore } from '../../auth/stores/useAuthStore';

// Note: Ensure this is set in your .env as a fallback
const DEFAULT_WEBHOOK_URL = (import.meta as any).env.VITE_N8N_WEBHOOK_URL || 'http://localhost:5678/webhook/0c9080f0-697f-446f-bc92-83dfd807e368/chat';

export const sendChatToAi = async (chatInput: string, sessionId: string, customWebhookUrl?: string) => {
  const { guestId } = useAuthStore.getState();
  const webhookUrl = customWebhookUrl || DEFAULT_WEBHOOK_URL;

  try {
    const response = await axios.post(webhookUrl, {
      chatInput,
      sessionId
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': i18n.language || 'en',
        'x-guest-id': guestId || ''
      },
      timeout: 60000 // 60 seconds timeout as AI can be slow
    });

    return response.data;
  } catch (error) {
    console.error('Failed to communicate with AI Agent:', error);
    throw error;
  }
};
